import React ,{useContext} from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";

const IntersessionRow = ({ info: { id, name, status, schoolYear,permalink } }) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const navigateToEditCourses = () => {
    navigate(`/edit-courses/${permalink}/${id}`);
  };

  const navigateToEditProfile = () => {
    navigate(`/editLELO/${id}`);
  };

  return (
    <tr>
      <td>{name}</td>
      <td>{status}</td>
      <td>{schoolYear}</td>
      {user &&
            (                             
              user.userStatus === "Admin" ||
              user.userStatus === "Super Admin") && (

      <td>
        <div
          className="btn btn-llac-dark-green"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={navigateToEditProfile}
        >
          Edit
        </div>
      </td>
       )}
      <td>
        <div
          className="btn btn-llac-dark-green"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={navigateToEditCourses}
        >
          Edit Courses
        </div>
      </td>
    </tr>
  );
};

export default IntersessionRow;
